/* src/app/_shared/components/toolbar-button/toolbar-button.component.scss */
:host {
  display: block;
  min-width: 32px;
  height: 32px;
  position: relative;
  z-index: 1000;
  font-weight: bold;
  --icon-color: var(--ion-color-primary);
  --icon-font-size: var(--icon-size);
}
.flow-toolbar-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: var(--radius);
}
.flow-toolbar-button.disabled ion-icon,
.flow-toolbar-button.disabled .text-container {
  color: var(--ion-color-medium);
}
.flow-toolbar-button.danger {
  --icon-color: var(--ion-color-danger);
}
.flow-toolbar-button:not(.disabled).active {
  background-color: var(--ion-color-light);
}
.flow-toolbar-button ion-icon {
  color: var(--icon-color);
  font-size: var(--icon-font-size);
}
.flow-toolbar-button ion-icon.has-text {
  padding-left: calc(var(--space-right) / 2);
}
.flow-toolbar-button .text-container {
  padding: 0 calc(var(--space-right) / 2);
  color: var(--icon-color);
}
/*# sourceMappingURL=toolbar-button.component-65OX4YK3.css.map */
